import { Colors } from '../../consts/Colors';
import RoundedButton2 from '../RoundedButton2';
import Card1 from './Card1';
import { CartesInfos, TextContents } from '../../consts/DataGame1';
import DragManager from '../DragManager';

// Création du deck de jeu pour la partie 1

export default class Deck1 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, w, h) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.num = 1


        this.dragManager = new DragManager(this.scene);
        this.rect = this.scene.add.rexRoundRectangle(0, 0, w, h, 26, Colors.Elmt.Blue).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);

        this.repLogo = this.scene.add.image(-125, -190, 'goodAnswer').setOrigin(0.5);
        this.add(this.repLogo);
        this.repLogo.setAlpha(0)

        this.repTextGood = this.scene.add.text(-92, -190, "BRAVO", {
            font: "40px MassiliaBold",
            color: Colors.Text.Green
        }).setOrigin(0, 0.5)
        this.add(this.repTextGood)
        this.repTextGood.setAlpha(0)

        this.repTextWrong = this.scene.add.text(-146, -208, "MAUVAISE\nRÉPONSE", {
            font: "40px MassiliaBold",
            color: Colors.Text.Red,
            align: "left"
        }).setOrigin(0, 0)
        this.add(this.repTextWrong)
        this.repTextWrong.setAlpha(0)

        this.cardFeedBack = this.scene.add.text(-146, this.repTextGood.y + 25, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.", {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "left",
            lineSpacing: 5,
            wordWrap: { width: 290, useAdvancedWrap: true }
        }).setOrigin(0, 0)
        this.add(this.cardFeedBack)
        this.cardFeedBack.setAlpha(0)

        this.nextBtn = new RoundedButton2(this.scene, 0, 120, 200, "Suivant");
        this.add(this.nextBtn);
        this.nextBtn.setAlpha(0)
        this.nextBtn.setClickFunction(() => {
            this.scene.game.data.cardNumber1++
            this.nextBtn.setAlpha(0)
            // this.scene.game.data.score.bravo++
            if (this.num === 8) {
                // this.scene.scene.start('Game2')
                // this.scene.endGame()
                this.scene.launchEndPopup()

                // this.scene.transitionOut()
            } else {
                this.setDeckAction(CartesInfos[this.scene.game.data.cardNumber1])
            }
        })
        // this.scene.game.data.score.mauvais++

        this.rectLabel = this.scene.add.rexRoundRectangle(0, this.rect.height / 2, 336, 88, {
            tl: 0,
            tr: 0,
            bl: 26,
            br: 26
        }, Colors.Elmt.DarkBlue).setOrigin(0.5, 1);
        this.add(this.rectLabel);

        this.numText = this.scene.add.text(145, this.rectLabel.y - 44, this.num + "/8", {
            font: "20px MassiliaExtraLight",
            color: Colors.Text.Blue
        }).setOrigin(1, 0.5)
        this.add(this.numText)

        this.labelName = this.scene.add.text(-144, this.rectLabel.y - 40, 'Stock à vendre', {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Blue,
            wordWrap: { width: 249, useAdvancedWrap: true }
        }).setOrigin(0, 0.5)
        this.add(this.labelName)


        this.title = this.scene.createTextElement(-171, -474, TextContents.title)
        this.subtitle = this.scene.createTextElement(-171, -444, TextContents.subtitle)
        this.consigne = this.scene.createTextElement(-167, 252, TextContents.consigne)
        this.add(this.title)
        this.add(this.subtitle)
        this.add(this.consigne)
    }

    setDeckAction(cardData) {
        this.cardData = cardData
        this.card = new Card1(this.scene, 0, 30, this.cardData, this);
        this.add(this.card);
        this.dragManager.addDraggable(this.card);
        this.repLogo.setAlpha(0)
        this.repTextGood.setAlpha(0)
        this.repTextWrong.setAlpha(0)
        // this.cardFeedBackWrong.setAlpha(0)
        this.cardFeedBack.setAlpha(0)

        this.labelName.setText(this.cardData.titre)
        this.rect.fillColor = Colors.Elmt.Blue
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.rectLabel.fillColor = Colors.Elmt.White
        this.numText.setColor(Colors.Text.Blue)
        this.labelName.setColor(Colors.Text.Blue)
        this.num = this.scene.game.data.cardNumber1 + 1
        this.numText.setText(this.num + "/8")
        this.rectLabel.setAlpha(0)
        this.numText.setAlpha(1)
        this.labelName.setAlpha(1)
    }
    setDeckTrue(content) {
        this.repLogo.setAlpha(1)
        this.repTextGood.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.nextBtn.setAlpha(1)
        this.cardFeedBack.setY(this.repTextGood.y + 25)
        this.cardFeedBack.setText(content)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Green, 1);
        this.rectLabel.fillColor = Colors.Elmt.Green
        this.numText.setColor(Colors.Text.White)
        this.labelName.setColor(Colors.Text.White)
        this.rectLabel.setAlpha(1)
    }
    setDeckFalse(content) {
        this.repTextWrong.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.nextBtn.setAlpha(1)
        this.cardFeedBack.setText(content)
        this.cardFeedBack.setY(this.repTextWrong.y + this.repTextWrong.height / 2 + 45)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Red, 1);
        this.rectLabel.fillColor = Colors.Elmt.Red
        this.numText.setColor(Colors.Text.White)
        this.labelName.setColor(Colors.Text.White)
        this.rectLabel.setAlpha(1)
    }
}